var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-hero"},[_c('div',{staticClass:"project-hero__slide"},[(_vm.items.length)?_c('Slider',{attrs:{"value":_vm.items,"manualNavigation":"","display-thumbnail":""}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }